module.exports = __webpack_public_path__ + "img/notesattachments-es.7c4d5e88.png";